export const categories = [
    {
        id: 'unit-conversion',
        name: 'Unit Conversion',
        description: 'Convert between different units of measurement',
        icon: 'SwapHoriz',
    },
    {
        id: 'measurements',
        name: 'Measurements',
        description: 'Calculate areas, volumes, and other measurements',
        icon: 'Straighten',
    },
    {
        id: 'math',
        name: 'Mathematical',
        description: 'Perform mathematical calculations and operations',
        icon: 'Calculate',
    },
    {
        id: 'fabrication',
        name: 'Fabrication',
        description: 'Sheet-metal bending and flat patterns',
        icon: 'Build',
    },
];
